import Collage from './collage/script';
import CoverChapter from './covers/chapter/script';
import CoverIntro from './covers/intro/script';
import FixedHeader from './fixed-header/script';
import Footer from './footer/script';
import Gallery from './gallery/script';
import ImageFeed from './image-feed/script';
import Letter from './letter/script';
import Nav from './nav/script';
import NextChapter from './next-chapter/script';
import Quote from './quote/script';
import Share from './share/script';
import VideoPlayer from './video-player/script';
import VideoTrigger from './video-trigger/script';


export default {
	[Collage.selector]: { Class: Collage },
	[CoverChapter.selector]: { Class: CoverChapter },
	[CoverIntro.selector]: { Class: CoverIntro },
	[FixedHeader.selector]: { Class: FixedHeader },
	[Footer.selector]: { Class: Footer },
	[Gallery.selector]: { Class: Gallery },
	[ImageFeed.selector]: { Class: ImageFeed },
	[Letter.selector]: { Class: Letter },
	[Nav.selector]: { Class: Nav },
	[NextChapter.selector]: { Class: NextChapter },
	[Quote.selector]: { Class: Quote },
	[Share.selector]: { Class: Share },
	[VideoPlayer.selector]: { Class: VideoPlayer },
	[VideoTrigger.selector]: { Class: VideoTrigger }
};
